import type {
  CreateInternalNoteBody,
  CreateInternalNoteResponse,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { requestInternalNotesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useCreateRequestInternalNote(
  requestId: number,
): UseMutationResult<
  CreateInternalNoteResponse,
  Error,
  CreateInternalNoteBody
> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateInternalNoteBody) =>
      apiClient
        .url(`/requests/${requestId}/internal-notes`)
        .post(body)
        .json<CreateInternalNoteResponse>(),
    onError: () => {
      toast.add(
        { title: "Failed to create note", type: "error" },
        { timeout: 5000 },
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: requestInternalNotesKeys.byRequestId(requestId),
      });
    },
  });
}
